const genres: ListType[] = [
	{
		name: "Action",
		id: "Action",
		type: "genre",
	},
	{
		name: "Adventure",
		id: "Adventure",
		type: "genre",
	},
	{
		name: "Comedy",
		id: "Comedy",
		type: "genre",
	},
	{
		name: "Drama",
		id: "Drama",
		type: "genre",
	},
	{
		name: "Ecchi",
		id: "Ecchi",
		type: "genre",
	},
	{
		name: "Fantasy",
		id: "Fantasy",
		type: "genre",
	},
	{
		name: "Horror",
		id: "Horror",
		type: "genre",
	},
	{
		name: "Mahou Shoujo",
		id: "Mahou Shoujo",
		type: "genre",
	},
	{
		name: "Mecha",
		id: "Mecha",
		type: "genre",
	},
	{
		name: "Music",
		id: "Music",
		type: "genre",
	},
	{
		name: "Mystery",
		id: "Mystery",
		type: "genre",
	},
	{
		name: "Psychological",
		id: "Psychological",
		type: "genre",
	},
	{
		name: "Romance",
		id: "Romance",
		type: "genre",
	},
	{
		name: "Sci-Fi",
		id: "Sci-Fi",
		type: "genre",
	},
	{
		name: "Slice of Life",
		id: "Slice of Life",
		type: "genre",
	},
	{
		name: "Sports",
		id: "Sports",
		type: "genre",
	},
	{
		name: "Supernatural",
		id: "Supernatural",
		type: "genre",
	},
	{
		name: "Thriller",
		id: "Supernatural",
		type: "genre",
	},
]
const seasons = [
	{
		name: "Summer",
		id: "SUMMER",
		type: "season",
	},
	{
		name: "Spring",
		id: "SPRING",
		type: "season",
	},
	{
		name: "Fall",
		id: "FALL",
		type: "season",
	},
	{
		name: "Winter",
		id: "WINTER",
		type: "season",
	},
]
const year: ListType[] = [
	{ name: 1950, id: 1950, type: "year" },
	{ name: 1951, id: 1951, type: "year" },
	{ name: 1952, id: 1952, type: "year" },
	{ name: 1953, id: 1953, type: "year" },
	{ name: 1954, id: 1954, type: "year" },
	{ name: 1955, id: 1955, type: "year" },
	{ name: 1956, id: 1956, type: "year" },
	{ name: 1957, id: 1957, type: "year" },
	{ name: 1958, id: 1958, type: "year" },
	{ name: 1959, id: 1959, type: "year" },
	{ name: 1960, id: 1960, type: "year" },
	{ name: 1961, id: 1961, type: "year" },
	{ name: 1962, id: 1962, type: "year" },
	{ name: 1963, id: 1963, type: "year" },
	{ name: 1964, id: 1964, type: "year" },
	{ name: 1965, id: 1965, type: "year" },
	{ name: 1966, id: 1966, type: "year" },
	{ name: 1967, id: 1967, type: "year" },
	{ name: 1968, id: 1968, type: "year" },
	{ name: 1969, id: 1969, type: "year" },
	{ name: 1970, id: 1970, type: "year" },
	{ name: 1971, id: 1971, type: "year" },
	{ name: 1972, id: 1972, type: "year" },
	{ name: 1973, id: 1973, type: "year" },
	{ name: 1974, id: 1974, type: "year" },
	{ name: 1975, id: 1975, type: "year" },
	{ name: 1976, id: 1976, type: "year" },
	{ name: 1977, id: 1977, type: "year" },
	{ name: 1978, id: 1978, type: "year" },
	{ name: 1979, id: 1979, type: "year" },
	{ name: 1980, id: 1980, type: "year" },
	{ name: 1981, id: 1981, type: "year" },
	{ name: 1982, id: 1982, type: "year" },
	{ name: 1983, id: 1983, type: "year" },
	{ name: 1984, id: 1984, type: "year" },
	{ name: 1985, id: 1985, type: "year" },
	{ name: 1986, id: 1986, type: "year" },
	{ name: 1987, id: 1987, type: "year" },
	{ name: 1988, id: 1988, type: "year" },
	{ name: 1989, id: 1989, type: "year" },
	{ name: 1990, id: 1990, type: "year" },
	{ name: 1991, id: 1991, type: "year" },
	{ name: 1992, id: 1992, type: "year" },
	{ name: 1993, id: 1993, type: "year" },
	{ name: 1994, id: 1994, type: "year" },
	{ name: 1995, id: 1995, type: "year" },
	{ name: 1996, id: 1996, type: "year" },
	{ name: 1997, id: 1997, type: "year" },
	{ name: 1998, id: 1998, type: "year" },
	{ name: 1999, id: 1999, type: "year" },
	{ name: 2000, id: 2000, type: "year" },
	{ name: 2001, id: 2001, type: "year" },
	{ name: 2002, id: 2002, type: "year" },
	{ name: 2003, id: 2003, type: "year" },
	{ name: 2004, id: 2004, type: "year" },
	{ name: 2005, id: 2005, type: "year" },
	{ name: 2006, id: 2006, type: "year" },
	{ name: 2007, id: 2007, type: "year" },
	{ name: 2008, id: 2008, type: "year" },
	{ name: 2009, id: 2009, type: "year" },
	{ name: 2010, id: 2010, type: "year" },
	{ name: 2011, id: 2011, type: "year" },
	{ name: 2012, id: 2012, type: "year" },
	{ name: 2013, id: 2013, type: "year" },
	{ name: 2014, id: 2014, type: "year" },
	{ name: 2015, id: 2015, type: "year" },
	{ name: 2016, id: 2016, type: "year" },
	{ name: 2017, id: 2017, type: "year" },
	{ name: 2018, id: 2018, type: "year" },
	{ name: 2019, id: 2019, type: "year" },
	{ name: 2020, id: 2020, type: "year" },
	{ name: 2021, id: 2021, type: "year" },
]
const formats = [
	{
		name: "tv",
		id: "TV",
		type: "format",
	},
	{
		name: "ova",
		id: "OVA",
		type: "format",
	},
	{
		name: "movie",
		id: "MOVIE",
		type: "format",
	},
	{
		name: "special",
		id: "SPECIAL",
		type: "format",
	},
	{
		name: "ona",
		id: "ONA",
		type: "format",
	},
	{
		name: "music",
		id: "MUSIC",
		type: "format",
	},
]
export const selectLists: selectListsType[] = [
	{
		type: "Genre",
		list: genres,
	},
	{
		type: "Season",
		list: seasons,
	},
	{
		type: "Year",
		list: year.reverse(),
	},
	{
		type: "Format",
		list: formats,
	},
]

export type ListType = {
	name: string | number
	type: string
	id: string | number
}

export type selectListsType = {
	type: string
	list: ListType[]
}
